/** Client-side helpers aligned with backend (220 wpm). */
import { resolveLocalizedValue } from "./blogLocales";

export function stripHtml(html) {
    return String(html || "")
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

export function estimateReadingMinutes(html, wordsPerMinute = 220) {
    const text = stripHtml(html);
    const words = text.split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.ceil(words / wordsPerMinute));
}

/** Prefer stored `readingTimeMinutes`; otherwise estimate from localized HTML content. */
export function readingTimeLabelFromBlog(blog, lang) {
    const stored = blog?.readingTimeMinutes;
    if (typeof stored === "number" && Number.isFinite(stored) && stored >= 1) {
        return `${Math.round(stored)} min read`;
    }
    const html =
        typeof blog?.content === "string"
            ? blog.content
            : resolveLocalizedValue(blog?.content, lang);
    return `${estimateReadingMinutes(html)} min read`;
}
